export const CustomerType = {
    PERCUST: "PERCUST",
    CORPCUST: "CORPCUST"
}